import { ButtonHTMLAttributes, ComponentClass, createElement, forwardRef, FunctionComponent, NamedExoticComponent, ReactNode } from "react";
import classNames from "classnames";
import { RefType } from "../../types";
import { genericMemo } from "../../utils";

import styles from "./ButtonGroupItem.styles.module.scss";


export type BaseButtonGroupItemProps<P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement> = {
  component?: string | FunctionComponent<P> | ComponentClass<P, any> | NamedExoticComponent<P>
  ref?: RefType<R>
  current?: boolean
  className?: string
  disabled?: boolean
  children?: ReactNode
}

export type ButtonGroupItemProps<P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement> =
  BaseButtonGroupItemProps<P, R> & P;

const ButtonGroupItemComponent = <P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement>(props: ButtonGroupItemProps<P, R>) => <></>;
type ButtonGroupItemComponentType = typeof ButtonGroupItemComponent;

export const ButtonGroupItem = genericMemo(forwardRef(<P extends object = ButtonHTMLAttributes<HTMLButtonElement>, R extends unknown = HTMLButtonElement>(
  {
    component = "button",
    disabled = false,
    className,
    children,
    current = false,
    ...props
  }: ButtonGroupItemProps<P, R>,
  ref: RefType<R>,
) => {
  return createElement(component as any, {
    ref,
    disabled,
    className: classNames(
      className,
      styles.root,
      {
        [styles.disabled]: disabled,
        [styles.current]: current,
      },
    ),
    children,
    ...props,
  });
}) as ButtonGroupItemComponentType);
